import React, { useId } from 'react';

function Select({
  className = '',
  disabled = false,
  error,
  fullWidth = false,
  helperText,
  id,
  label,
  name,
  onChange,
  options = [],
  placeholder,
  size = 'medium',
  value,
  ...rest
}) {
  const generatedId = useId();
  const fieldId = id || name || `custom-select-${generatedId}`;
  const helpId = `${fieldId}-help`;

  return (
    <div className={[
      'custom-select',
      `custom-select--${size}`,
      fullWidth ? 'custom-select--full' : '',
      error ? 'custom-select--error' : '',
      disabled ? 'custom-select--disabled' : '',
      className,
    ].filter(Boolean).join(' ')}>
      {label && <label className="custom-select__label" htmlFor={fieldId}>{label}</label>}
      <select
        id={fieldId}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className="custom-select__field"
        aria-invalid={Boolean(error)}
        aria-describedby={(helperText || error) ? helpId : undefined}
        {...rest}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((option) => (
          <option key={option.value ?? option.label} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {(helperText || error) && (
        <span id={helpId} className="custom-select__help">{error || helperText}</span>
      )}
    </div>
  );
}

export default Select;
